import { FastArrowUp } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconFastArrowUp12Line = createIcon(FastArrowUp, 12, "Line");
export const IconFastArrowUp16Line = createIcon(FastArrowUp, 16, "Line");
export const IconFastArrowUp20Line = createIcon(FastArrowUp, 20, "Line");
export const IconFastArrowUp24Line = createIcon(FastArrowUp, 24, "Line");
export const IconFastArrowUp32Line = createIcon(FastArrowUp, 32, "Line");
export const IconFastArrowUp48Line = createIcon(FastArrowUp, 48, "Line");
export const IconFastArrowUp64Line = createIcon(FastArrowUp, 64, "Line");
